import { Typography, useTheme } from "@mui/material"


const CommonLabel = ({children,sx,variant,...props}) =>{
    const theme = useTheme();
    
    return (
        <Typography gutterBottom={false} variant={variant} sx= {{fontFamily:theme.typography.fontFamily,letterSpacing:'0.5px', wordBreak:'none',...sx}} {...props} >{children}</Typography>
    )
}
export default CommonLabel
